/**************************************************
 * Nombre:       Formulario_Contacto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, ApartmentOutlined, PhoneAndroidOutlined} from "@mui/icons-material";
import {NEGRITA} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Formulario_Contacto = ({...props}) => {
    const {sCell} = useResponsive()

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{boxShadow: 1, p: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2}}>
                    <Typography sx={{fontSize: 38, fontFamily: NEGRITA, fontWeight: 600, lineHeight: 1.2}}>Crezcamos
                        juntos. Déjanos tu
                        mensaje</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'} dato={'celular'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Correo'} dato={'correo'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Asunto'} dato={'asunto'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Mensaje'} dato={'mensaje'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Button fullWidth sx={{color: '#fff'}}>Enviar Mensaje</Button>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Contacto